import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styled, { css } from 'styled-components';
import { Text } from '../../text';
var defaultStyles = {
  position: 'relative',
  marginBottom: 16,
  paddingLeft: 32,
  '&:last-child': {
    marginBottom: 0
  },
  '&:before': {
    position: 'absolute'
  }
};
var bulletItem = css(["&:before{position:absolute;content:'\u2022';border-radius:50%;left:0;top:0;}"]);
var numbersItem = css(["&:before{position:absolute;counter-increment:number;content:counter(number) '.';font-weight:500;left:0;top:0;}"]);
var ListItem = styled(Text).attrs(function (_ref) {
  var _ref$$styles = _ref.$styles,
      $styles = _ref$$styles === void 0 ? {} : _ref$$styles;
  return {
    as: 'li',
    $styles: _objectSpread(_objectSpread({}, defaultStyles), $styles)
  };
}).withConfig({
  displayName: "ListItem",
  componentId: "sc-q5z4mz-0"
})(["p{margin:0;font-size:inherit;line-height:inherit;}ul &{", "}ol &{", "}"], bulletItem, numbersItem);
export default ListItem;